<template>

  <modalo
    title="Quickin Mail"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => provider">

    <form
      id="el-form"
      v-on:submit.prevent="save(provider)">
      <div class="form-group">
        <label>Nick</label>

        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="provider.native_email_nick"
            maxlength="30">
          <div class="input-group-append">
            <span class="input-group-text">@{{ domain }}</span>
          </div>
        </div>
        <ValidateMessage :error="validateErrors.native_email_nick" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="el-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'QuickinForm',
  components: {
  },
  props: {
    'initProvider': {
      type: Object,
      default: () => { return {} }
    },
    'domain': {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      provider: this.defaultValues(this.initProvider),
      validateErrors: {}
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    },
    profile () {
      return this.$store.getters.getProfile
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    save
    */
    save (data) {
      this.loading = true
      this.axios.put('/accounts/' + this.$store.getters.getAccount._id + '/profile/email-provider/native', this.provider).then(response => {
        this.$emit('updated', response.data)
      }).catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProfileEmailSettings/QuickinForm.vue